import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Box from "@mui/material/Box";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import {
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Tooltip,
} from "@mui/material";
import axios from "axios";
import { Button } from "react-bootstrap";
import { fetchStudent } from "../../Redux/Reducers/StudentReducer";
import PageHeader1 from "../../components/common/PageHeader1";
import { usePermissions } from "../../context/AuthContext";

function StudentList() {
  const { can } = usePermissions();
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({});
  const student = useSelector((state) => state.StudentReducer?.students);
  const pagination = useSelector((state) => state?.StudentReducer?.pagination);
  const loading = useSelector((state => state?.StudentReducer?.loading));

  const [filterModel, setFilterModel] = useState({
    items: [],
    quickFilterExcludeHiddenColumns: true,
    quickFilterValues: [""],
  });

  useEffect(() => {
    const { page, pageSize } = paginationModel;
    dispatch(fetchStudent({ page: page + 1, limit: pageSize }));
  }, [paginationModel, dispatch]);

  const rows = Array.isArray(student)
    ? student?.map((item, index) => {
      const courseDetails = item?.courseId ?? {};
      const userDetails = item;

      return {
        sono: paginationModel.page * paginationModel.pageSize + index + 1,
        fullName: userDetails?.name ?? "-",
        mobileNumber: userDetails?.mobile ?? "-",
        title: courseDetails?.title ?? "-",
        batchName: courseDetails?.batchDetails?.map(batch => batch?.batchName ?? "-").join(", ") ?? "-",
        tutorsName: courseDetails?.tutorsName ?? "-",
        staus: "Active",
        _id: item?._id,
        createdAt: userDetails?.createdAt
          ? new Date(userDetails?.createdAt).toLocaleString()
          : "",
      };
    })
    : [];

  function deleteCategory(id) {
    const token = localStorage.getItem("vedhvidhi-admin-token");

    axios.delete(`${process.env.REACT_APP_BASEURL}/admin/enrollment/${id}`, {
      headers: {
        Authorization: token,
      }
    })
      .then(response => {
        if (response.data.status) {
          const { page, pageSize } = paginationModel;
          dispatch(fetchStudent({ page: page + 1, limit: pageSize }));
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  const handleClickOpen = (id) => {
    setSelectedUserId(id);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedUserId(null);
  };

  const handleDelete = () => {
    if (selectedUserId) {
      deleteCategory(selectedUserId);
    }
    handleClose();
  };

  const columns = [
    { field: "sono", headerName: "S.No", width: 100 },
    { field: "fullName", headerName: "Full Name", width: 160 },
    { field: "mobileNumber", headerName: "Mobile No.", width: 160 },
    { field: "title", headerName: "Course Title", width: 200 },
    { field: "batchName", headerName: "Name of Batch", width: 160 },
    { field: "tutorsName", headerName: "Tutors Name", width: 160 },
    { field: "staus", headerName: "Status", width: 160 },
    { field: "createdAt", headerName: "Created At", width: 200 },
    ...(can('student_management:delete') || can('student_management:view')? [{
      field: "actions",
      headerName: "Actions",
      width: 150,
      renderCell: ({ row }) => (
        <div>
          {can('student_management:view') && (<Tooltip title="View Student">
            <IconButton component={Link} to={process.env.PUBLIC_URL + `/student-view/${row?._id}`}>
              <i className="icofont-eye text-info"></i>
            </IconButton>
          </Tooltip>)}
          {can('student_management:delete') && (
            <Tooltip title="Delete Student">
              <IconButton onClick={() => handleClickOpen(row?._id)}>
                <i className="icofont-ui-delete text-danger"></i>
              </IconButton>
            </Tooltip>
          )}
        </div>
      ),
    }] : []),
  ];

  return (
    <div className="body d-flex py-1">
      <div className="container-xxl">
        <div className="row g-0 mb-3">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                <PageHeader1 pagetitle="Student Management List" />
                <div
                  id="myDataTable_wrapper"
                  className="dataTables_wrapper dt-bootstrap5 no-footer"
                >
                  <div className="row">
                    <div className="col-sm-12">
                      <Box sx={{ width: 1 }}>
                        <Box sx={{ height: 400, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                          {loading ? (
                            <CircularProgress />
                          ) : (
                            <DataGrid
                              columns={columns}
                              rows={rows}
                              getRowId={(row) => row._id}
                              disableColumnFilter
                              disableDensitySelector
                              slots={{ toolbar: GridToolbar }}
                              filterModel={filterModel}
                              onFilterModelChange={(newModel) =>
                                setFilterModel(newModel)
                              }
                              slotProps={{ toolbar: { showQuickFilter: true } }}
                              columnVisibilityModel={columnVisibilityModel}
                              onColumnVisibilityModelChange={(newModel) =>
                                setColumnVisibilityModel(newModel)
                              }
                              paginationMode="server"
                              rowCount={pagination?.totalDocs || 0}
                              pageSizeOptions={[10, 25, 50, 100]}
                              paginationModel={paginationModel}
                              onPaginationModelChange={setPaginationModel}
                              disableRowSelectionOnClick
                            />
                          )}
                        </Box>
                      </Box>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogTitle id="alert-dialog-title">{"Delete Confirmation"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete this record?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} variant="secondary">
              Cancel
            </Button>
            <Button onClick={handleDelete} variant="danger" autoFocus>
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
}

export default StudentList;